"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipText = exports.LegalTextMedium = exports.LegalText = exports.PrimaryButtonText = exports.AlertAction = exports.AlertText = exports.AlertTitle = exports.TextFieldPlaceholder = exports.TextFieldText = exports.TextFieldLabel = exports.SearchBarText = exports.SearchBarPlaceholder = exports.ListRowSecondarySelected = exports.ListRowSubtextSelected = exports.ListRowTitleSelected = exports.ListRowSecondaryLargeSelected = exports.ListRowSubtextLargeSelected = exports.ListRowTitleLargeSelected = exports.ListRowSecondary = exports.ListRowSubtext = exports.ListRowTitle = exports.ListRowSecondaryLarge = exports.ListRowSubtextLarge = exports.ListRowTitleLarge = exports.HighlightLabel = exports.CalloutLabel = exports.Label = exports.SmallHighlightLabel = exports.SmallCalloutLabel = exports.SmallLabel = exports.NavBarTitle = exports.NavBarActionDisabled = exports.NavBarAction = exports.ContentActionDisabled = exports.ContentAction = exports.ContentBody = exports.SectionSubtext = exports.SectionTitle = exports.SectionTitleLarge = exports.PageSubtext = exports.PageDescriptionBody = exports.PageTitle = exports.MajorPageTitle = void 0;

var BaseStyles = _interopRequireWildcard(require("./base-styles"));

var _constants = require("../constants");

var _colors = _interopRequireDefault(require("../../colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-enable no-unused-vars */
var MajorPageTitle = _objectSpread({}, BaseStyles.Bold32);

exports.MajorPageTitle = MajorPageTitle;

var PageTitle = _objectSpread({}, BaseStyles.Bold24);

exports.PageTitle = PageTitle;

var PageDescriptionBody = _objectSpread({}, BaseStyles.Medium16, {
  lineHeight: _constants.LineHeights.Medium,
  color: _colors.default.TextTertiary
});

exports.PageDescriptionBody = PageDescriptionBody;

var PageSubtext = _objectSpread({}, BaseStyles.Medium16, {
  color: _colors.default.TextTertiary
});

exports.PageSubtext = PageSubtext;

var SectionTitleLarge = _objectSpread({}, BaseStyles.Caps18);

exports.SectionTitleLarge = SectionTitleLarge;

var SectionTitle = _objectSpread({}, BaseStyles.Caps16);

exports.SectionTitle = SectionTitle;

var SectionSubtext = _objectSpread({}, BaseStyles.Medium14, {
  color: _colors.default.TextTertiary
});

exports.SectionSubtext = SectionSubtext;

var ContentBody = _objectSpread({}, BaseStyles.Medium16, {
  lineHeight: _constants.LineHeights.Medium,
  color: _colors.default.TextTertiary
});

exports.ContentBody = ContentBody;

var ContentAction = _objectSpread({}, BaseStyles.Medium16, {
  color: _colors.default.TextAction
});

exports.ContentAction = ContentAction;

var ContentActionDisabled = _objectSpread({}, BaseStyles.Medium16, {
  color: _colors.default.SystemGrey60
});

exports.ContentActionDisabled = ContentActionDisabled;

var NavBarAction = _objectSpread({}, BaseStyles.Medium18, {
  color: _colors.default.TextAction
});

exports.NavBarAction = NavBarAction;

var NavBarActionDisabled = _objectSpread({}, BaseStyles.Medium18, {
  color: _colors.default.SystemGrey60
});

exports.NavBarActionDisabled = NavBarActionDisabled;

var NavBarTitle = _objectSpread({}, BaseStyles.Medium18);

exports.NavBarTitle = NavBarTitle;

var SmallLabel = _objectSpread({}, BaseStyles.Caps10);

exports.SmallLabel = SmallLabel;

var SmallCalloutLabel = _objectSpread({}, BaseStyles.Caps10, {
  color: _colors.default.SystemRed60
});

exports.SmallCalloutLabel = SmallCalloutLabel;

var SmallHighlightLabel = _objectSpread({}, BaseStyles.Caps10, {
  color: _colors.default.TextHighlight
});

exports.SmallHighlightLabel = SmallHighlightLabel;

var Label = _objectSpread({}, BaseStyles.Caps12);

exports.Label = Label;

var CalloutLabel = _objectSpread({}, BaseStyles.Caps12, {
  color: _colors.default.SystemRed60
});

exports.CalloutLabel = CalloutLabel;

var HighlightLabel = _objectSpread({}, BaseStyles.Caps12, {
  color: _colors.default.TextHighlight
});

exports.HighlightLabel = HighlightLabel;

var ListRowTitleLarge = _objectSpread({}, BaseStyles.Bold18, {
  overflow: _constants.Overflows.Truncate
});

exports.ListRowTitleLarge = ListRowTitleLarge;

var ListRowSubtextLarge = _objectSpread({}, BaseStyles.Medium14, {
  overflow: _constants.Overflows.Truncate,
  color: _colors.default.TextTertiary
});

exports.ListRowSubtextLarge = ListRowSubtextLarge;

var ListRowSecondaryLarge = _objectSpread({}, BaseStyles.Medium18, {
  overflow: _constants.Overflows.Truncate,
  color: _colors.default.TextTertiary
});

exports.ListRowSecondaryLarge = ListRowSecondaryLarge;

var ListRowTitle = _objectSpread({}, BaseStyles.Medium16, {
  overflow: _constants.Overflows.Truncate
});

exports.ListRowTitle = ListRowTitle;

var ListRowSubtext = _objectSpread({}, BaseStyles.Medium12, {
  overflow: _constants.Overflows.Truncate,
  color: _colors.default.TextTertiary
});

exports.ListRowSubtext = ListRowSubtext;

var ListRowSecondary = _objectSpread({}, BaseStyles.Medium16, {
  overflow: _constants.Overflows.Truncate,
  color: _colors.default.TextTertiary
});

exports.ListRowSecondary = ListRowSecondary;

var ListRowTitleLargeSelected = _objectSpread({}, BaseStyles.Bold18, {
  overflow: _constants.Overflows.Truncate,
  color: _colors.default.SelectedText
});

exports.ListRowTitleLargeSelected = ListRowTitleLargeSelected;

var ListRowSubtextLargeSelected = _objectSpread({}, BaseStyles.Medium14, {
  overflow: _constants.Overflows.Truncate,
  color: _colors.default.SelectedText
});

exports.ListRowSubtextLargeSelected = ListRowSubtextLargeSelected;

var ListRowSecondaryLargeSelected = _objectSpread({}, BaseStyles.Medium18, {
  overflow: _constants.Overflows.Truncate,
  color: _colors.default.SelectedText
});

exports.ListRowSecondaryLargeSelected = ListRowSecondaryLargeSelected;

var ListRowTitleSelected = _objectSpread({}, BaseStyles.Medium16, {
  overflow: _constants.Overflows.Truncate,
  color: _colors.default.SelectedText
});

exports.ListRowTitleSelected = ListRowTitleSelected;

var ListRowSubtextSelected = _objectSpread({}, BaseStyles.Medium12, {
  overflow: _constants.Overflows.Truncate,
  color: _colors.default.SelectedText
});

exports.ListRowSubtextSelected = ListRowSubtextSelected;

var ListRowSecondarySelected = _objectSpread({}, BaseStyles.Medium16, {
  overflow: _constants.Overflows.Truncate,
  color: _colors.default.SelectedText
});

exports.ListRowSecondarySelected = ListRowSecondarySelected;

var SearchBarPlaceholder = _objectSpread({}, BaseStyles.Medium18);

exports.SearchBarPlaceholder = SearchBarPlaceholder;

var SearchBarText = _objectSpread({}, BaseStyles.Medium18);

exports.SearchBarText = SearchBarText;

var TextFieldLabel = _objectSpread({}, BaseStyles.Bold16);

exports.TextFieldLabel = TextFieldLabel;

var TextFieldText = _objectSpread({}, BaseStyles.Medium16, {
  color: _colors.default.TextTertiary
});

exports.TextFieldText = TextFieldText;

var TextFieldPlaceholder = _objectSpread({}, BaseStyles.Medium16, {
  color: _colors.default.TextTertiary
});

exports.TextFieldPlaceholder = TextFieldPlaceholder;

var AlertTitle = _objectSpread({}, BaseStyles.Medium18, {
  textAlign: _constants.TextAlignments.Center
});

exports.AlertTitle = AlertTitle;

var AlertText = _objectSpread({}, BaseStyles.Medium14, {
  textAlign: _constants.TextAlignments.Center,
  lineHeight: _constants.LineHeights.Medium,
  color: _colors.default.TextTertiary
});

exports.AlertText = AlertText;

var AlertAction = _objectSpread({}, BaseStyles.Medium18, {
  color: _colors.default.TextAction,
  textAlign: _constants.TextAlignments.Center
});

exports.AlertAction = AlertAction;

var PrimaryButtonText = _objectSpread({}, BaseStyles.Medium18, {
  color: _colors.default.ButtonPrimaryForeground,
  textAlign: _constants.TextAlignments.Center
});

exports.PrimaryButtonText = PrimaryButtonText;

var LegalText = _objectSpread({}, BaseStyles.Regular12);

exports.LegalText = LegalText;

var LegalTextMedium = _objectSpread({}, BaseStyles.Medium12);

exports.LegalTextMedium = LegalTextMedium;

var TooltipText = _objectSpread({}, BaseStyles.Medium14, {
  color: _colors.default.SystemGrey20
});

exports.TooltipText = TooltipText;